import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import trafficMessageIconResource from "../../assets/trafficSituation2.svg"
import { SwedishTrafficMessage } from "../../services/RuteplanAPI";


export function SvenskeTrafikkmeldinger(props: IRoutePartProps) {
 
    return (
        <>
            {props.roadFeatures && props.roadFeatures.swedishTrafficMessages && 
            <List>
                {props.roadFeatures.swedishTrafficMessages.map( (trafikkmelding: SwedishTrafficMessage, index: number) => (
                    <ListItem
                    key={trafikkmelding.situationId + index} 
                    className="roadFeature"
                    onClick={(event) => {props.onClick(trafikkmelding, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(trafikkmelding)}
                    onMouseLeave={props.onMouseLeaveItem}>            
                        <img src={trafficMessageIconResource} height="24" style={{paddingRight:"5px"}} alt="Trafikkmelding icon" title="trafikkmeldingIcon" />
                        {trafikkmelding.situationId}
                    </ListItem>
                ))}
            </List>
            }
        </>
    )
}